export const tuneSubscribe = {
  stateTuneChLatestPost: "state.tuneCh.latestPost/*",
  stateTuneChMeta: "state.tuneCh.meta/*",
  statePosts: "state.posts/*",
  stateRank: "state.rank/*",
  stateRankLatestPost: "state.rank.latestPost/*",
  stateRankMeta: "state.rank.meta/*",
  stateRankMetaFavicon: "state.rank.meta.favicon",
  stateRankAll: "state.rankAll/*",
  stateRankAllLatestPost: "state.rankAll.latestPost/*",
  stateRankAllMeta: "state.rankAll.meta/*",
  stateRankAllMetaFavicon: "state.rankAll.meta.favicon",
} as const;

export type TuneSubscribeKey =
  (typeof tuneSubscribe)[keyof typeof tuneSubscribe];

/** @deprecated Use TuneProjection via subscription/TuneProjection instead. */
export type TuneSubscribeOption = Partial<Record<TuneSubscribeKey, boolean>>;

export const tuneSubscribeOptionInit: TuneSubscribeOption = Object.fromEntries(
  Object.values(tuneSubscribe).map((key) => [key, false])
) as TuneSubscribeOption;

export const tuneSubscribeOptionAllTrue: TuneSubscribeOption = {
  [tuneSubscribe.stateTuneChLatestPost]: true,
  [tuneSubscribe.stateTuneChMeta]: true,
  [tuneSubscribe.statePosts]: true,
  [tuneSubscribe.stateRank]: true,
  [tuneSubscribe.stateRankLatestPost]: true,
  [tuneSubscribe.stateRankMeta]: true,
  [tuneSubscribe.stateRankMetaFavicon]: true,
  [tuneSubscribe.stateRankAll]: true,
  [tuneSubscribe.stateRankAllLatestPost]: true,
  [tuneSubscribe.stateRankAllMeta]: true,
  [tuneSubscribe.stateRankAllMetaFavicon]: true,
};

export const tuneSubscribeMethods = Object.values(tuneSubscribe);

export const tuneSubscribeOptionLabels: Record<TuneSubscribeKey, string> =
  Object.fromEntries(
    Object.values(tuneSubscribe).map((key) => [key, key])
  ) as Record<TuneSubscribeKey, string>;
